/**
 * HTTP 请求封装
 * 基于 axios，统一错误处理和拦截器
 */
import axios from 'axios'
import { API_CONFIG } from '@/config/index.js'
import { handleNetworkError } from '@/errors/handler.js'
import { logger } from '@/utils/logger.js'

const log = logger.module('HTTP')

const http = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截：自动注入 token
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('h5im_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
      config.headers['token'] = token
    }
    log.debug(`[${config.method?.toUpperCase()}] ${config.url}`)
    return config
  },
  (error) => {
    log.error('Request error:', error.message)
    return Promise.reject(error)
  }
)

// 响应拦截：统一错误处理
http.interceptors.response.use(
  (response) => {
    const res = response.data
    // 兼容后端多种成功结构
    // 支持：code=0/200/1/z0002，status=1/success
    const code = res.code
    const status = res.status
    const isSuccess =
      code === 0 || code === 200 || code === 1 ||
      code === '0' || code === '200' || code === '1' || code === 'z0002' ||
      status === 1 || status === 'success'
    if (isSuccess) {
      return res
    }
    // 业务错误
    return Promise.reject(new Error(res.message || '请求失败'))
  },
  (error) => {
    if (error.response?.status === 401) {
      // token 失效，清空并回到错误页
      log.warn('Token expired')
      localStorage.removeItem('h5im_token')
      window.location.href = '/error?reason=expired'
    } else {
      handleNetworkError(error, { url: error.config?.url })
    }
    return Promise.reject(error)
  }
)

export default http
